import React, { useState } from 'react';
import { useApp } from '../../contexts/AppContext';
import { ChevronDown, FlaskConical, Shield, BookOpen } from 'lucide-react';

const tabs = [
  { id: 'analyzer', label: 'Aktuelle Bewertung' },
  { id: 'portfolio', label: 'Immobilienportfolio' },
  { id: 'taxOptimizer', label: 'Steueroptimierung', isNew: true },
  { id: 'mietpreise', label: 'Info Mietpreise' },
  { id: 'statistik', label: 'Statistik' },
  { id: 'wasserfall', label: 'Wasserfall' },
  { id: 'loi', label: 'Angebotschreiben' },
  { id: 'report', label: 'Report' },
  { id: 'sanierung', label: 'Sanierungsrechner' },
  { id: 'experimental', label: 'Experimental Lab', icon: FlaskConical, isNew: true },
  { id: 'compliance', label: 'Legal Compliance', icon: Shield, isNew: true },
  { id: 'readme', label: 'Readme', icon: BookOpen, isNew: true },
];

const TabNavigation: React.FC = () => {
  const { activeTab, setActiveTab } = useApp();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const activeTabLabel = tabs.find(t => t.id === activeTab)?.label || '';

  return (
    <>
      {/* Mobile dropdown */}
      <div className="md:hidden border-b border-gray-200">
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="w-full px-4 py-3 text-left font-medium text-gray-700 flex items-center justify-between hover:bg-gray-50"
        >
          <span>{activeTabLabel}</span>
          <ChevronDown className={`w-5 h-5 transition-transform ${isMobileMenuOpen ? 'rotate-180' : ''}`} />
        </button>
        {isMobileMenuOpen && (
          <div className="bg-white border-t border-gray-200 shadow-lg absolute z-10 w-full">
            {tabs.map(tab => (
              <button
                key={tab.id}
                onClick={() => {
                  setActiveTab(tab.id);
                  setIsMobileMenuOpen(false);
                }}
                className={`w-full px-4 py-3 text-left font-medium hover:bg-gray-50 ${
                  activeTab === tab.id ? 'bg-blue-50 text-blue-600' : 'text-gray-600'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        )}
      </div>

      {/* Desktop tabs */}
      <div className="hidden md:flex border-b border-gray-200 overflow-x-auto">
        {tabs.map(tab => {
          const Icon = tab.icon;
          return (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-3 font-medium text-center text-gray-600 border-b-2 border-transparent hover:text-gray-800 hover:border-gray-300 focus:outline-none whitespace-nowrap flex items-center ${
                activeTab === tab.id ? 'tab-active' : ''
              }`}
            >
              {Icon && <Icon className="w-4 h-4 mr-1" />}
              {tab.label}
              {tab.isNew && (
                <span className="ml-1 px-1.5 py-0.5 text-xs bg-purple-600 text-white rounded">NEU</span>
              )}
            </button>
          );
        })}
      </div>
    </>
  );
};

export default TabNavigation;